import type { SVGProps } from 'react';
const SvgWarning = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 16"
    height={16}
    fill="none"
    width={16}
    {...props}
  >
    <g clipPath="url(#Warning_svg__a)" fill="currentColor">
      <path d="M8 4.25a.75.75 0 0 1 .75.75v4a.75.75 0 0 1-1.5 0V5A.75.75 0 0 1 8 4.25M8.75 11.25a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0" />
      <path
        d="M8 .25a7.75 7.75 0 1 0 0 15.5A7.75 7.75 0 0 0 8 .25M1.75 8a6.25 6.25 0 1 1 12.5 0 6.25 6.25 0 0 1-12.5 0"
        fillRule="evenodd"
        clipRule="evenodd"
      />
    </g>
    <defs>
      <clipPath id="Warning_svg__a">
        <path d="M0 0h16v16H0z" fill="#fff" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgWarning;
